// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"f1baea83","11":"ff9dc060","40":"2d00bfbd","156":"97dba99e","936":"5fef033a","964":"b26d4685"}[chunkId] + ".chunk.js";
};